import React from "react"
import { Updater, any, async, fromJSX } from "widgets-for-react"
import { DrupalPopup, PopupState } from "./popup.state"
import { State } from "../cmsPage.widget"
import { Entity } from "ts-lenses"
import { PopupLayout } from "./popup.layout"
import { popupWasClosed, updaters } from "./popup.api"

export const popupWidget = (state: PopupState) => any<Updater<PopupState>>([
  async<Array<DrupalPopup>>(state.popups)
    .map<Updater<PopupState>>(u => os => Entity(os).set("popups", op => u(op)).commit()),
  fromJSX(setState => {
    if (state.popups.kind !== "loaded") return <></>
    if (popupWasClosed(state)) return <></>

    const popups = state.popups.value

    if (popups.filter(p => p.open).length < 1) return <></>

    return <div className="popup__wrapper" aria-live="polite">
      {popups.map((popup, index) => {
        if (!popup.open) return <></>
        return <PopupLayout.Dialog
          popup={popup}
          togglePopup={() => setState(s0 => updaters.closePopup(s0, index))}
        />
      })}
    </div>
  })
])
  .map<Updater<State>>(u => s0 => Entity(s0).set("popupState", os => u(os)).commit())